function initPopup() {
  // We check Klaviyo's local storage
  const klaviyoSessionStorage = JSON.parse(sessionStorage.getItem("klaviyoFormSubmit"));
  const klaviyoLocalStorage = JSON.parse(localStorage.getItem("klaviyoOnsite"));
  const newsletterFormId = "XMPbWS";
  
  // If the form has been submitted in the current session, nothing happens
  if(klaviyoSessionStorage?.submittedForms[newsletterFormId]) return;

  // If the form Id is included in the disabled forms list, we init the popup with delay
  if(klaviyoLocalStorage?.viewedForms?.modal?.disabledForms[newsletterFormId] || klaviyoLocalStorage?.viewedForms?.modal?.viewedForms[newsletterFormId]) {
    showPopup();
  }
}

// Enable and display popup
function showPopup() {
  let localStorageData = JSON.parse(localStorage.getItem("questionnaire"));
  let sessionStorageData = JSON.parse(sessionStorage.getItem("preference_center"));
  
  // If we're on the homepage or the preference center page, we don't show the popup
  if(window.location.pathname === "/" || window.location.pathname === "/pages/preference-center") return;
  
  // If the user has already subscribed or closed the popup, we don't show the popup
  if(localStorageData?.hasSubscribed || sessionStorageData?.hasClosed) return;

  // Otherwise, we show the popup
  const popup = document.querySelector(".PreferenceCenterPopup");
  const popupCloseBtn = document.querySelector(".PreferenceCenterPopup__Close");
  const popupBtn = document.querySelector(".PreferenceCenterPopup .btn");

  setTimeout(function() {
    popup.style.display = "block";

    setTimeout(function() {
      popup.style.transform = "unset";
    }, 150);
  }, popup.dataset.delay * 1000);

  popupBtn.addEventListener("click", function(event) {
    event.preventDefault();

    sessionStorage.setItem("preference_center", JSON.stringify({hasClosed: true}));

    window.location.href = popupBtn.getAttribute("href");
  });

  popupCloseBtn.addEventListener("click", function() {
    sessionStorage.setItem("preference_center", JSON.stringify({hasClosed: true}));

    popup.style.transform = "translateX(-200%)";

    setTimeout(function() {
      popup.style.display = "none";
    }, 300);
  });
}

document.addEventListener("DOMContentLoaded", function() {
  initPopup();
});